import { useAtom } from "jotai";
import { useCallback, useState } from "react";
import { useErrorHandler } from "react-error-boundary";
import OtpInput from 'react-otp-input';

import { showLoadingSpinnerAtom } from "../../../lander-quiz/lander-quiz.state";
import { FKCService } from "../../fkc.service";
import { pagesAtom } from "../../fkc.state";
import { FallbackPages, Pages } from "../../fkc.types";
import { ActionButton } from "../shared/submit-button/submit-button.component";

interface ResendMessage {
  status: "success" | "error";
  message: string;
}

export function VerificationPage(): JSX.Element {
  const [otp, setOtp] = useState<string>("");
  const [resendMessage, setResendMessage] = useState<ResendMessage | null>(null);

  const [, setPage] = useAtom(pagesAtom);
  const [, setIsLoading] = useAtom(showLoadingSpinnerAtom);

  const handleWidgetError = useErrorHandler();

  const email = window.theme.Sweepstake.prototype.retrieveSubmission()?.data?.email;

  const submitVerificationCode = useCallback((): void => {
    setIsLoading(true);

    FKCService
      .verifyAccount(email, otp, handleWidgetError)
      .then(() => setPage(Pages.PLAID))
      .catch(() => setPage(FallbackPages.VERIFICATION_RETRY))
      .finally(() => setIsLoading(false));
  }, [otp, setPage, handleWidgetError, setIsLoading, email]);

  const resendVerificationCode = useCallback((): void => {
    FKCService
      .resendVerificationCode(email)
      .then(() => setResendMessage({ status: "success", message: "Code sent successfully" }))
      .catch(() => setResendMessage({ status: "error", message: "Failed to send code, please try again" }));
  }, [setResendMessage, email]);

  return (
    <>
      <strong className="fkc__children--title">
        Please check your email and enter the code to verify your account
      </strong>

      <OtpInput
        value={otp}
        onChange={setOtp}
        numInputs={6}
        renderInput={(props) => <input {...props} />}
        inputStyle="otp-input"
        inputType="number"
      />

      <p className="fkc__children--resend-code">
        Didn&apos;t get a code? Check your spam folder and search for
        <span> &quot;rewards.finfare&quot; </span> 
        in your email if you have not yet received the verification email or,&nbsp;
        <button onClick={resendVerificationCode}>click here</button> to send another
      </p>
      {resendMessage &&
        <span className={`fkc__children--resend-message--${resendMessage.status}`}>
          {resendMessage.message}
        </span>
      }

      <ActionButton
        disabled={otp.length !== 6}
        className="three-quarters-width"
        onClick={submitVerificationCode}
      >
        Continue
      </ActionButton>
    </>
  );
}
